import type { IconData } from '@stacksjs/iconify-core'

export const buildingRealEastateProjectBlueprint: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.14 4.57V6.1h21.34v22.85H3.05v1.53H32V4.57z\"/><path fill=\"currentColor\" d=\"M19.81 13.72h1.52v1.52h-1.52Zm-1.52 7.61h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M12.19 24.38H6.1v1.53h10.66v-1.53h-3.04v-7.62h1.52v-1.52h3.05v-1.52h-3.05v-3.05h10.67v3.05h-3.05v1.52h3.05v9.14h-3.05v-4.57h-3.05v1.52h1.52v4.58h6.1V9.14H12.19v1.53h1.53v4.57H9.14v1.52h3.05zM9.14 9.14h1.53v1.53H9.14ZM1.52 27.43h1.53v1.52H1.52Z\"/><path fill=\"currentColor\" d=\"M3.05 24.38v-1.52h4.57V3.05H6.1V1.52H3.05v1.53H1.52v1.52H0v22.86h1.52v-3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default buildingRealEastateProjectBlueprint
